import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'
// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login } from './views/Pages';

import { Provider } from "react-redux";
import store from "./store/index";
import { connect } from "react-redux";


const defaultComponentByStatus = {
  'AUTHENTICATED': DefaultLayout,
  'ANONYMOUS': Login
}

const mapStateToProps = state => {
  return { authStatus: state.authStatus };
};

const ConnectedApp = (state) => {

  let ComponentToRender = defaultComponentByStatus[state.authStatus];
  return (
      <HashRouter>
        <Switch>
          <Route path="/" name="Home" component={ComponentToRender} />
        </Switch>
      </HashRouter>
  );
}

const App = connect(mapStateToProps)(ConnectedApp);

export default () =>
  <Provider store={store}>
    <App />
  </Provider>;



// WEBPACK FOOTER //
// ./src/App.js